// src/api/auth.js

export async function refreshAccessToken() {
    const email = localStorage.getItem("user_email"); // email должен сохраняться после логина
    const refreshToken = localStorage.getItem("refresh_token");
  
    if (!email || !refreshToken) {
      throw new Error("Нет email или refresh_token для обновления токена");
    }
  
    const response = await fetch("http://qcan-dev.smart-era.com:8001/auth/v1/user/refresh-access", {
      method: "PUT",
      headers: {
        "accept": "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        refresh_token: refreshToken,
      }),
    });
  
    if (!response.ok) {
      throw new Error("Ошибка обновления access_token");
    }
  
    const data = await response.json();
    
    // Сохраняем новые токены и время истечения в localStorage
    localStorage.setItem("access_token", data.access_token);
    localStorage.setItem("refresh_token", data.refresh_token);
    localStorage.setItem("access_expiration_time", data.access_expiration_time);
  
    return data.access_token;
  }
  